<template>
  <!-- Лампочка идеи с искрами, пока экран открыт (П25; f23-form-idea-thanks) -->
  <div class="idea-art" aria-hidden="true">
    <img :src="images.base" :srcset="`${images.base2x} 2x`" alt="">
    <img
      v-for="(s, i) in sparks"
      :key="i"
      class="idea-art__spark"
      :src="images.sparks"
      :srcset="`${images.sparks2x} 2x`"
      alt=""
      :style="{ '--x': `${s.x}%`, '--y': `${s.y}%`, '--r': `${s.r}%`, animationDelay: `${s.delay}s` }"
    >
  </div>
</template>

<script>
  import base from '@/assets/support/anim/idea-base.png'
  import base2x from '@/assets/support/anim/idea-base@2x.png'
  import sparks from '@/assets/support/anim/idea-sparkles.png'
  import sparks2x from '@/assets/support/anim/idea-sparkles@2x.png'

  // Центр (x, y) и полуразмер r каждой искры в % картинки - из шейдера idea-sparkles.glsl.
  // delay отрицательный: при открытии искры уже в разных фазах, соседние сдвинуты на 0,37 периода.
  const SPARKS = [
    { x: 11.91, y: 21.68, r: 6.45, delay: -0.6 },
    { x: 65.53, y: 67.97, r: 6.35, delay: -1.49 },
    { x: 11.91, y: 61.91, r: 4.49, delay: -2.38 },
    { x: 64.84, y: 15.63, r: 4.49, delay: -0.86 },
    { x: 71.48, y: 60.74, r: 3.22, delay: -1.75 },
    { x: 19.14, y: 15.23, r: 3.32, delay: -0.24 },
    { x: 18.36, y: 68.85, r: 3.22, delay: -1.13 },
    { x: 70.9, y: 22.75, r: 3.22, delay: -2.02 },
  ]

  export default {
    name: 'Sparkles',
    data () {
      return { sparks: SPARKS, images: { base, base2x, sparks, sparks2x } }
    },
  }
</script>

<style scoped lang="less">
.idea-art {
  position: relative;
  width: 200px;
  aspect-ratio: 1;

  img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }
}

/* Копия слоя искр, обрезанная до своей искры; растёт и крутится вокруг её центра */
.idea-art__spark {
  clip-path: inset(calc(var(--y) - var(--r)) calc(100% - var(--x) - var(--r)) calc(100% - var(--y) - var(--r)) calc(var(--x) - var(--r)));
  transform-origin: var(--x) var(--y);
  animation: idea-spark 2.4s ease-in-out infinite;
}

@keyframes idea-spark {
  0%,
  100% {
    opacity: 0.25;
    transform: scale(0.45) rotate(-10deg);
  }

  50% {
    opacity: 1;
    transform: scale(1.2) rotate(10deg);
  }
}

/* Без движения - искры в полный размер, как статичная картинка */
@media (prefers-reduced-motion: reduce) {
  .idea-art__spark {
    animation: none;
    opacity: 1;
    transform: none;
  }
}
</style>
